const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, 1, 98), new Map([[`class`, `o-rhythm--generous o-container--pad`]]), true, false, 1));
                this.echo(this.include(context, this.source, this.loadTemplate(`a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, 10, 99), new Map([[`class`, `o-rhythm--generous o-container--pad t-alternate`]]), true, false, 10));
            }

            getTemplateName() {
                return `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, ``);
            }
        }],
        [98, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h1>t-`);
                this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, (context.has(`theme`) ? context.get(`theme`) : null), `html`, null, true]));
                this.echo(`</h1>
    `);
                this.echo(this.include(context, this.source, `@cloudfour/design/demo/theme-content.twig`, undefined, false, false, 6));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/demo/styles.twig`, undefined, false, false, 7));
                this.echo(`  `);
            }

            getTemplateName() {
                return `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, ``);
            }
        }],
        [99, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, 10);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h2>t-alternate within t-`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`theme`) ? context.get(`theme`) : null), `html`, null, true]));
                this.echo(`</h2>
    `);
                this.echo(this.include(context, this.source, `@cloudfour/design/demo/theme-content.twig`, undefined, false, false, 15));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/demo/styles.twig`, undefined, false, false, 16));
                this.echo(`  `);
            }

            getTemplateName() {
                return `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3');

let template = env.loadTemplate('a1e2997a0c07d18ee0072aa74da1664edd33bd6df64027e16d9e0eac43a75fc3');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/design/demo/theme-alternate.twig", args: context }
     );
     return rendered;;
};